import React, { useContext, useState } from 'react';
import useAnalytics from 'helpers/useAnalytics';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { saveSourceFields } from 'store/sources';
import makeSourceCreateBaseUrl from 'pages/Directory/helpers/makeSourceCreateBaseUrl';

// Components
import CardHeader from '@material-ui/core/CardHeader';
import SourceContext from 'helpers/SourceContext';
import TextField from '@material-ui/core/TextField';

import Base from 'pages/Directory/Base';
import { MAP_ATTRIBUTES_URL } from 'pages/Directory/consts';

interface OAuthFormParams {
  dataSourceFilter?: string;
  whereStatement?: string;
}

function WorkdayDataFilterForm() {
  const classes = useStyles();
  const analytics = useAnalytics();
  const history = useHistory();
  const dispatch = useDispatch();
  const sourceContext = useContext(SourceContext);
  const { sourceInfo } = sourceContext;

  const {
    dataSourceFilter = 'allActiveWorkers',
    whereStatement = '',
  } = sourceInfo.fields || {};

  const initFilterParams: OAuthFormParams = {
    dataSourceFilter,
    whereStatement,
  };

  const [filterParams, setFilterParams] = useState(initFilterParams);


  const handleChange = (
    fieldName: string,
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const value = e.target.value.trim();

    setFilterParams(current => ({ ...current, [fieldName]: value }));
  };

  const handleNext = async () => {
    await dispatch(saveSourceFields(sourceInfo.sourceId, filterParams));

    const baseUrl = makeSourceCreateBaseUrl(sourceInfo.directoryId, sourceInfo.sourceId);

    history.replace(`${baseUrl}${MAP_ATTRIBUTES_URL}`);

    analytics.track('Wizard - Workday OAuth Step Completed', {
      category: 'AD - Directories',
    });
  };

  function formIsValid(): boolean {
    // TODO (rbickham11): Do we want to try to validate WQL structure at all here?
    return !!filterParams.dataSourceFilter;
  }

  return (
    <Base onNext={handleNext} disableNextButton={!formIsValid()} currentStep={3}>
      <CardHeader
        title="Workday Query Language (WQL) Filter"
        subheader="We use WQL to retrieve Worker data from Workday. The data source filter and optional where statement can be used to limit the which workers we retrieve. By default, we retrieve all active workers."
      />
      <div className={classes.inputContainer}>
        <TextField
          data-cy="data-client-id-input"
          label="Data Source Filter"
          placeholder="Enter Data Source Filter"
          defaultValue={initFilterParams.dataSourceFilter}
          onChange={e => handleChange('dataSourceFilter', e)}
        />
        <TextField
          data-cy="data-client-id-input"
          label="WQL Where Statement (Optional)"
          placeholder="Enter WQL Where Statement"
          defaultValue={initFilterParams.whereStatement}
          onChange={e => handleChange('whereStatement', e)}
        />
      </div>
    </Base>
  );
}

const useStyles = makeStyles(theme => ({
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: theme.spacing(3),
    maxWidth: 366,
  },
}));

export default WorkdayDataFilterForm;
